import React, { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useHostContext } from '../hooks/useHostContext';
import { api } from '../api/client';
import { RIDER_THEME } from '../pages/rider/RiderV2Constants';

function digitsOnly(value) {
  return String(value || '').replace(/\D/g, '');
}

function firstLetter(name) {
  const text = String(name || '').trim();
  return text ? text.slice(0, 1) : 'ش';
}

export default function TrialEndedScreen() {
  const { user, logout } = useAuth();
  const host = useHostContext();
  const portal = host?.portal;
  const isRider = portal === 'rider';
  const isCustomer = portal === 'customer';
  const isMerchant = portal === 'merchant';
  const [brand, setBrand] = useState(null);

  const companyName = brand?.name || user?.company_name || '';
  const phone = brand?.phone || user?.company_phone || '';
  const wa = digitsOnly(phone);
  const slug = user?.slug || host?.companySlug;

  useEffect(() => {
    if (!slug) return undefined;
    let cancelled = false;
    api.getCompanyBySlug(slug)
      .then((data) => {
        if (!cancelled && data?.name) setBrand(data);
      })
      .catch(() => {});
    return () => { cancelled = true; };
  }, [slug]);

  const logoUrl = isRider
    ? (brand?.rider_app_logo_url || user?.rider_app_logo_url || brand?.logo_url || user?.company_logo_url)
    : isMerchant
      ? (brand?.merchant_app_logo_url || user?.merchant_app_logo_url || brand?.logo_url || user?.company_logo_url)
      : (brand?.logo_url || user?.company_logo_url);

  const palette = isRider
    ? {
        pageBg: RIDER_THEME.bg,
        cardBg: RIDER_THEME.card,
        border: RIDER_THEME.border,
        title: RIDER_THEME.text,
        body: RIDER_THEME.textMid,
        accent: RIDER_THEME.accent,
        buttonBg: RIDER_THEME.accent,
        buttonColor: '#1A1205',
        iconBg: 'rgba(245,158,11,0.12)',
      }
    : isCustomer
      ? {
          pageBg: '#F4F1EA',
          cardBg: '#fff',
          border: '#E8E0D4',
          title: '#2C2416',
          body: '#6B5E4E',
          accent: '#3E2C6E',
          buttonBg: '#3E2C6E',
          buttonColor: '#fff',
          iconBg: 'rgba(62,44,110,0.08)',
        }
      : {
          pageBg: '#F7F5FB',
          cardBg: '#fff',
          border: '#E6E0F0',
          title: '#3E2C6E',
          body: '#5C5670',
          accent: '#E0A526',
          buttonBg: '#3E2C6E',
          buttonColor: '#fff',
          iconBg: 'rgba(224,165,38,0.14)',
        };

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 24,
        boxSizing: 'border-box',
        background: palette.pageBg,
        direction: 'rtl',
        fontFamily: "'Cairo', Tahoma, sans-serif",
      }}
    >
      <div
        style={{
          width: '100%',
          maxWidth: 440,
          background: palette.cardBg,
          border: `1px solid ${palette.border}`,
          borderRadius: 20,
          padding: '32px 28px',
          boxShadow: isRider ? '0 18px 48px rgba(0,0,0,0.45)' : '0 16px 40px rgba(62,44,110,0.08)',
          textAlign: 'center',
        }}
      >
        {logoUrl ? (
          <img
            src={logoUrl}
            alt={companyName || 'الشركة'}
            style={{
              width: 88,
              height: 88,
              objectFit: 'contain',
              margin: '0 auto 18px',
              display: 'block',
              borderRadius: 16,
              background: isRider ? 'rgba(255,255,255,0.04)' : '#fff',
            }}
          />
        ) : (
          <div
            style={{
              width: 88,
              height: 88,
              borderRadius: 16,
              margin: '0 auto 18px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              background: palette.iconBg,
              color: palette.title,
              fontSize: 32,
              fontWeight: 800,
            }}
            aria-hidden
          >
            {firstLetter(companyName)}
          </div>
        )}
        <h1 style={{ margin: '0 0 8px', fontSize: 22, color: palette.title, fontWeight: 800 }}>
          انتهت الفترة التجريبية
        </h1>
        {companyName ? (
          <p style={{ margin: '0 0 14px', fontSize: 14, color: palette.accent, fontWeight: 700 }}>
            {companyName}
          </p>
        ) : null}
        <p style={{ margin: '0 0 12px', fontSize: 15, lineHeight: 1.8, color: palette.body }}>
          شكراً لاستخدامكم منصة الجيزة دليفري.
        </p>
        <p style={{ margin: '0 0 18px', fontSize: 15, lineHeight: 1.8, color: palette.body }}>
          انتهت الفترة التجريبية لحسابكم. يمكنكم التواصل مع الشركة لتجديد الاشتراك أو لأي دعم فني آخر.
        </p>
        {phone ? (
          <a
            href={wa ? `https://wa.me/${wa}` : `tel:${phone}`}
            style={{
              display: 'inline-block',
              marginBottom: 22,
              color: palette.title,
              fontWeight: 700,
              textDecoration: 'none',
              direction: 'ltr',
            }}
          >
            {phone}
          </a>
        ) : null}
        {user?.name ? (
          <p style={{ margin: '0 0 22px', fontSize: 13, color: palette.body }}>
            مرحباً {user.name} — تم تسجيل دخولكم بنجاح.
          </p>
        ) : null}
        <button
          type="button"
          onClick={logout}
          style={{
            width: '100%',
            border: 'none',
            borderRadius: 12,
            padding: '12px 16px',
            background: palette.buttonBg,
            color: palette.buttonColor,
            fontSize: 15,
            fontWeight: 700,
            cursor: 'pointer',
            fontFamily: 'inherit',
          }}
        >
          تسجيل الخروج
        </button>
      </div>
    </div>
  );
}
